import Marquee from "react-fast-marquee";

const ITEMS = [
  "NABL Accredited",
  "Resilient Infrastructure",
  "Soil & Construction Testing",
  "Government & Private Sector",
  "Qualiz Testing Lab",
];

export default function Ribbon() {
  return (
    <div data-testid="ribbon" className="border-y border-[#27272a] bg-[#111111] py-5 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#f4f4f5] px-8">
              {t}
            </span>
            <span className="text-[#ff4500] text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
